<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3Zd3Yi/tc-custom/9781427860958.jpg?1704456352218" alt="This image is the cover for the book Gyakushu!, Volume 1, Gyakushu!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gyakushu!, Volume 1, Gyakushu!
      </h1>
      <p class="bookDescription body article font2">
        <p>A nameless man, bandaged from head to toe, stands alone in a field of fresh corpses and carnage. Blood drips from his sword, dying the virgin snow red. The battle may be over for now, but his one-man war has just begun. Mystery and intrigue surround this warrior, as clues about his past lead to a chilling confrontation in his future. The only certain thing in this world of ice and death is white-hot revenge.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dan Hipp
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tokyopop Verlag
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e8ec7e42